import "bootstrap/dist/css/bootstrap.min.css";

const Afooter = () => {
  return (
    <footer className="text-white mt-auto py-3" style={{
      background: "linear-gradient(135deg, #0D9488 0%, #0B7A6F 100%)",
      borderTop: "3px solid #0D9488"
    }}>
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6">
            <p className="small mb-0">🏛️ <strong>Admin Panel</strong> - Jain Samagra Portal</p>
          </div>
          <div className="col-md-6 text-end">
            <p className="small mb-0">© 2026 All rights reserved | Version 1.0</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Afooter;
